import React, { useEffect } from "react";
import { useAppContext } from '../context';
import { motion, AnimatePresence } from 'framer-motion';
import { Header } from "./Header";

interface ILayout {
    children: React.ReactNode;
}


const pageVariants = {
    initial: { opacity: 0, position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' },
    in: { opacity: 1 },
    out: { opacity: 0 }
};

const pageTransition = {
    type: 'tween',
    ease: 'anticipate',
    duration: 0.3
};

const AnimatedPage: React.FC<{ children: React.ReactNode; route: string }> = ({ children, route }) => (
    <motion.div
        key={route}
        initial="initial"
        animate="in"
        exit="out"
        variants={pageVariants as any}
        transition={pageTransition}
    >
        {children}
    </motion.div>
);

const classes = {
    mobile: {
        wrapper: "min-h-vh bg-vkusvill-green/70 overflow-hidden touch-none",
        container: "relative h-vh max-w-md mx-auto bg-[url('/images/noise.webp')]",
        main: "px-4"
    },
    desktop: {
        wrapper: "min-h-vh bg-vkusvill-green overflow-auto",
        container: "relative h-vh bg-[url('/images/noise.webp')]",
        main: "px-8"
    }
}
interface ILayout {
    children: React.ReactNode;
}

export const Layout: React.FC<ILayout> = ({ children }) => {
    const { currentRoute, isMobile } = useAppContext();
    const variant = isMobile ? 'mobile' : 'desktop';

    useEffect(() => {
        if (!isMobile || currentRoute === 'result' || currentRoute === 'start') return;
        const preventDefault = (e: any) => e.preventDefault();

        window.addEventListener('touchmove', preventDefault, { passive: false });

        return () => {
            window.removeEventListener('touchmove', preventDefault);
        };
    }, [isMobile, currentRoute]);

    return (
        <div className={classes[variant].wrapper}>
            <div className={classes[variant].container}>
                <Header />
                <main className={classes[variant].main}>
                    <AnimatePresence mode="wait">
                        <AnimatedPage route={currentRoute}>
                            {children}
                        </AnimatedPage>
                    </AnimatePresence>
                </main>
            </div>
        </div>
    );
};